<mat-progress-bar mode="determinate" [color]="(value1 > 90 ? 'primary': 'warn')" [value]="value1" class="width">
</mat-progress-bar>
<span class="width info-text" *ngIf="infoMessage">{{infoMessage}}</span>